import { ComponentType } from '@angular/cdk/overlay';
import { ListRendererWidget } from '../interfaces/list-renderer-widget';
import { Directive } from '@angular/core';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class ListRendererConfigBase {
  public widgets?: Record<string, ComponentType<ListRendererWidget>>;
}
